<template>
  <div class="home">
<!--新春全屏祝福层
    <div v-if="showNewYearOverlay" class="newyear-overlay">
      <button class="newyear-close-btn" @click="closeNewYearOverlay">×</button>
      <div class="newyear-content">
        <div class="newyear-main-text">恭贺新春</div>
        <div class="newyear-sub-text">万事如意 · 阖家安康 · 龙行大吉</div>
        <div class="newyear-org">广州市劳动保障学会祝你新年快乐</div>
        <div class="newyear-tips">本祝福将在 5 秒后自动关闭</div>
      </div>
    </div>-->

    <!-- 通知条 -->
    <div class="notice-bar" @mouseenter="stopNoticeScroll" @mouseleave="startNoticeScroll">
      <div class="notice-icon">
        <img src="http://www.gzhr.org.cn/api/images/view/1747972699069-873947487.png?token=892205f9b3a4e96347c4c4da4fc4c27a3e03b9d2f50d31b51c9c8b66125198cf" alt="通知" class="icon-img">
      </div>
      <div class="notice-content" ref="noticeContent">
        <div class="notice-text" :style="noticeStyle" ref="noticeText">
          <span class="notice-item">{{ noticeItems[0].content }}</span>
        </div>
      </div>
    </div>

    <div class="page-container">
      <!-- 顶部区域（轮播图和公告列表） -->
      <div class="top-section">
        <!-- 轮播图 -->
        <div class="banner">
          <div class="slider" @mouseenter="pauseAutoplay" @mouseleave="resumeAutoplay">
            <div class="slider-item" v-for="(slide, index) in bannerSlides" :key="index" 
                :class="{ active: currentSlideIndex === index }">
              <a :href="slide.linkUrl" target="_blank" v-if="slide.linkUrl">
                <img :src="slide.imageUrl" alt="轮播图" class="slider-img">
                <div class="slider-text">{{ slide.title }}</div>
              </a>
              <template v-else>
                <img :src="slide.imageUrl" alt="轮播图" class="slider-img">
                <div class="slider-text">{{ slide.title }}</div>
              </template>
            </div>
            <div class="slider-arrows">
              <div class="slider-arrow prev" @click="prevSlide">
                <i class="arrow-icon left"></i>
              </div>
              <div class="slider-arrow next" @click="nextSlide">
                <i class="arrow-icon right"></i>
              </div>
            </div>
            <div class="slider-indicators">
              <div 
                v-for="(_, index) in bannerSlides" 
                :key="'indicator-'+index"
                class="slider-indicator" 
                :class="{ active: currentSlideIndex === index }"
                @click="setSlide(index)">
              </div>
            </div>
          </div>
        </div>
        
        <!-- 公告列表 -->
        <div class="announcement-list">
          <!-- 顶部图片区域 -->
          <div class="announcement-image">
            <img :src="bannerUrl" alt="公告图片" class="announcement-img">
          </div>
          <div class="announcements-wrapper">
            <!-- 加载中 -->
            <div v-if="announcementLoading" class="announcement-loading">
              <div class="spinner-small"></div>
              <p>加载中...</p>
            </div>
            
            <!-- 加载错误 -->
            <div v-else-if="announcementError" class="announcement-error">
              <p>{{ announcementError }}</p>
              <button @click="fetchAnnouncementData" class="retry-button-small">重试</button>
            </div>
            
            <!-- 公告列表 -->
            <div v-else class="announcement-item" v-for="(item, index) in announcementItems" :key="'announce-'+index" @click="handleAnnouncementClick(item)">
              <div class="dot"></div>
              <a v-if="item.externalLink" 
                 :href="item.externalLink" 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 class="announcement-text">
                {{ item.title }}
                <span class="external-link-icon-small">
                  <i class="fas fa-external-link-alt"></i>
                </span>
              </a>
              <router-link v-else :to="item.link" class="announcement-text">{{ item.title }}</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="content-wrapper">
          <!-- 左侧内容 -->
          <div class="left-content">
            <!-- 新闻资讯 -->
            <div class="card news-card">
              <div class="card-header">
                <span class="icon-title">新闻资讯</span>
                <router-link to="/news" class="more">更多</router-link>
              </div>
              <div class="card-body">
                <!-- 加载中 -->
                <div v-if="newsLoading" class="loading-placeholder">
                  <div class="spinner-small"></div>
                  <p>加载中...</p>
                </div>
                
                <!-- 加载错误 -->
                <div v-else-if="newsError" class="error-message">
                  <p>{{ newsError }}</p>
                  <button @click="fetchNewsData" class="retry-button">重试</button>
                </div>
                
                <!-- 新闻列表 -->
                <ul v-else class="list">
                  <li class="list-item" v-for="item in newsData" :key="'news-'+item.id">
                    <a v-if="hasExternalLink(item)" 
                       :href="extractExternalLink(item.content)" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       class="title"
                       @click.prevent="handleExternalLinkClick(item, extractExternalLink(item.content))">
                      {{ item.title }}
                      <span class="external-link-icon">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <router-link v-else :to="'/news/' + item.id" class="title">{{ item.title }}</router-link>
                    <span class="date">{{ formatDate(item.publishDate) }}</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <!-- 政策法规 -->
            <div class="card">
              <div class="card-header">
                <span class="icon-title">政策法规</span>
                <router-link to="/policy" class="more">更多</router-link>
              </div>
              <div class="card-body">
                <!-- 加载中 -->
                <div v-if="policyLoading" class="loading-placeholder">
                  <div class="spinner-small"></div>
                  <p>加载中...</p>
                </div>
                
                <!-- 加载错误 -->
                <div v-else-if="policyError" class="error-message">
                  <p>{{ policyError }}</p>
                  <button @click="fetchPolicyData" class="retry-button">重试</button>
                </div>
                
                <!-- 政策列表 -->
                <ul v-else class="list">
                  <li class="list-item" v-for="item in policyData" :key="'policy-'+item.id">
                    <a v-if="hasExternalLink(item)" 
                       :href="extractExternalLink(item.content)" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       class="title"
                       @click.prevent="handleExternalLinkClick(item, extractExternalLink(item.content))">
                      {{ item.title }}
                      <span class="external-link-icon">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <router-link v-else :to="'/policy/' + item.id" class="title">{{ item.title }}</router-link>
                    <span class="date">{{ formatDate(item.publishDate) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 中间内容 -->
          <div class="center-content">
            <!-- 学会动态 -->
            <div class="card">
              <div class="card-header">
                <span class="icon-title">学会动态</span>
                <router-link to="/dynamics" class="more">更多</router-link>
              </div>
              <div class="card-body">
                <!-- 加载中 -->
                <div v-if="dynamicLoading" class="loading-placeholder">
                  <div class="spinner-small"></div>
                  <p>加载中...</p>
                </div>
                
                <!-- 加载错误 -->
                <div v-else-if="dynamicError" class="error-message">
                  <p>{{ dynamicError }}</p>
                  <button @click="fetchDynamicData" class="retry-button">重试</button>
                </div>
                
                <!-- 动态列表 -->
                <ul v-else class="list">
                  <li class="list-item" v-for="item in dynamicData" :key="'dynamic-'+item.id">
                    <a v-if="hasExternalLink(item)" 
                       :href="extractExternalLink(item.content)" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       class="title"
                       @click.prevent="handleExternalLinkClick(item, extractExternalLink(item.content))">
                      {{ item.title }}
                      <span class="external-link-icon">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <router-link v-else :to="'/dynamics/' + item.id" class="title">{{ item.title }}</router-link>
                    <span class="date">{{ formatDate(item.publishDate) }}</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <!-- 最新案例 -->
            <div class="card">
              <div class="card-header">
                <span class="icon-title">最新案例</span>
                <router-link to="/case-law" class="more">更多</router-link>
              </div>
              <div class="card-body">
                <!-- 加载中 -->
                <div v-if="caseLoading" class="loading-placeholder">
                  <div class="spinner-small"></div>
                  <p>加载中...</p>
                </div>
                
                <!-- 加载错误 -->
                <div v-else-if="caseError" class="error-message">
                  <p>{{ caseError }}</p>
                  <button @click="fetchCaseData" class="retry-button">重试</button>
                </div>
                
                <!-- 案例列表 -->
                <ul v-else class="list">
                  <li class="list-item" v-for="item in caseData" :key="'case-'+item.id">
                    <a v-if="hasExternalLink(item)" 
                       :href="extractExternalLink(item.content)" 
                       target="_blank" 
                       rel="noopener noreferrer" 
                       class="title"
                       @click.prevent="handleExternalLinkClick(item, extractExternalLink(item.content))">
                      {{ item.title }}
                      <span class="external-link-icon">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </a>
                    <router-link v-else :to="'/case-law/' + item.id" class="title">{{ item.title }}</router-link>
                    <span class="date">{{ formatDate(item.publishDate) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 右侧内容 -->
          <div class="right-content">
            <!-- 会员登录 -->
            <div class="card login-card">
              <div class="card-header">
                <span class="icon-title">会员登录</span>
              </div>
              <div class="card-body">
                <form class="login-form">
                  <div class="form-group">
                    <label class="form-label">账号:</label>
                    <input type="text" class="form-control" placeholder="请输入账号">
                  </div>
                  <div class="form-group">
                    <label class="form-label">密码:</label>
                    <input type="password" class="form-control" placeholder="请输入密码">
                  </div>
                  <button type="button" class="btn btn-login">登录</button>
                  <div class="form-links">
                    <a href="#" class="form-link">忘记密码</a>
                    <a href="#" class="form-link">注册</a>
                  </div>
                </form>
              </div>
            </div>
            <!-- 留言板 -->
            <div class="card login-card">
              <div class="card-header">
                <span class="icon-title">留言板</span>
              </div>
              <div class="card-body">
                <form class="message-form" @submit.prevent="submitMessage">
                  <div class="form-group">
                    <label class="form-label">姓名:</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="请输入您的姓名" 
                      v-model="messageForm.name"
                      required
                    >
                  </div>
                  <div class="form-group">
                    <label class="form-label">联系方式:</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="请输入电话或邮箱" 
                      v-model="messageForm.contact"
                      required
                    >
                  </div>
                  <div class="form-group">
                    <label class="form-label">留言内容:</label>
                    <textarea 
                      class="form-control message-textarea" 
                      placeholder="请输入您的留言内容" 
                      v-model="messageForm.content"
                      rows="1"
                      required
                    ></textarea>
                  </div>
                  <button type="submit" class="btn btn-submit" :disabled="isSubmitting">
                    {{ isSubmitting ? '提交中...' : '提交留言' }}
                  </button>
                  <div v-if="messageStatus" :class="['message-status', messageStatus.type]">
                    {{ messageStatus.text }}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- 案例解说部分 -->
        <div class="case-section">
          <div class="section-header">
            <h2 class="section-title">案例解说</h2>
            <router-link to="/case-law" class="more-link">更多</router-link>
          </div>
          <div class="case-examples">
            <div class="case-example" v-for="(item, index) in caseExamples" :key="'case-example-'+index" @click="navigateToCaseDetail(item)">
              <div class="case-image-wrapper">
                <img :src="item.image" alt="案例图片" class="case-image">
              </div>
              <div class="case-info">
                <div class="case-title">{{ item.title }}</div>
                <span class="case-free">免费</span>
              </div>
              <div class="case-views">
                <span class="views-count">{{ item.views }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 自定义提示框 -->
    <div class="custom-toast" v-if="showToast" :class="toastType">
      <div class="toast-content">
        <div class="toast-icon">
          <i :class="toastIcon"></i>
        </div>
        <div class="toast-message">{{ toastMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMAGES } from '@/assets/images/placeholder.js'
import newsService from '@/services/newsService'
import policyService from '@/services/policyService'
import dynamicService from '@/services/dynamicService'
import caseLawService from '@/services/caseLawService'
import bannerService from '@/services/bannerService'
import messageService from '@/services/messageService'

export default {
  name: 'HomeView',
  data() {
    return {
      bannerUrl: IMAGES.banner2,
      icons: IMAGES.icons,
      // 轮播图数据
      bannerSlides: [],
      bannerLoading: true,
      bannerError: null,
      // 备用轮播图数据
      defaultBannerSlides: [
        {
          id: 1,
          title: '广州市劳动保障学会参加社会科学普及活动',
          imageUrl: IMAGES.banner1,
          linkUrl: ''
        },
        {
          id: 2,
          title: '广州人力资源管理协会成为广东省2022年第一批职业技能等级认定培训评价组织',
          imageUrl: IMAGES.banner2,
          linkUrl: ''
        },
        {
          id: 3,
          title: '2021年首次会员单位线下讲座顺利举办',
          imageUrl: IMAGES.banner3,
          linkUrl: ''
        },
        {
          id: 4,
          title: '新业态与劳动保障权益" 第十一届广州学术季系列活动顺利举办',
          imageUrl: IMAGES.banner4,
          linkUrl: ''
        }
      ],
      // 公告列表数据
      announcementItems: [],
      announcementLoading: true,
      announcementError: null,
      // 备用公告数据
      defaultAnnouncementItems: [
        {
          id: 1,
          title: '广州市社科联党组织织建设工作第四片区联络工作会议在南沙召开',
          link: '/news/1'
        },
        {
          id: 2,
          title: '粤退休人员基本养老金上调7月底前发放',
          link: '/news/2'
        },
        {
          id: 3,
          title: '《民法典》对企业劳动用工的若干影响与注意事项',
          link: '/news/3'
        },
        {
          id: 4,
          title: '关于全面推行使用社保卡银行账户发放基本养老金的通知',
          link: '/news/4'
        },
        {
          id: 5,
          title: '关于拟复开展线下职业技能培训、评价和专业技术人员继续教育的通知',
          link: '/news/5'
        },
        {
          id: 6,
          title: '向会员开具证明的规定',
          link: '/news/6'
        }
      ],
      currentSlideIndex: 0,
      autoplayInterval: null,
      isAutoplayPaused: false,
      // 新闻数据
      newsData: [],
      newsLoading: true,
      newsError: null,
      // 政策法规数据
      policyData: [],
      policyLoading: true,
      policyError: null,
      // 学会动态数据
      dynamicData: [],
      dynamicLoading: true,
      dynamicError: null,
      noticeItems: [
        { content: '关注广州市劳动保障学会官方微信公众号，学会将不定期的举办公开课、培训讲座课程！主讲老师：广州市人力资源和社会保障局相关处室。期待您的参加~' }
      ],
      // 备用新闻数据，当API加载失败时使用
      newsItems: [
        { id: 1, title: '最新资讯，需要办失业保险金停发手续吗？', date: '2023-12-18' },
        { id: 2, title: '什么情形下劳动者能与用人单位解除劳动合同？', date: '2023-12-04' },
        { id: 3, title: '哪些情形下，用人单位应当向劳动者支付经济补偿？', date: '2023-11-02' },
        { id: 4, title: '以灵活就业人身身份缴纳养老保险，失业人员等：哪种更划算', date: '2023-10-20' },
        { id: 5, title: '职业病与工伤保险是什么关系？', date: '2023-07-26' },
        { id: 6, title: '关于养老保险缴费中断的影响', date: '2023-05-18' },
        { id: 7, title: '普宁劳人事争议调解仲裁全面启动在线调解模式', date: '2023-04-24' }
      ],
      // 备用政策法规数据
      policyItems: [
        { id: 1, title: '广州市人力资源和社会保障局关于调整部分人才入户条件的通知', date: '2024-02-20' },
        { id: 2, title: '广东省人力资源和社会保障厅 广东省医疗保障局关于进一步做好我省一体化经办信息系统上线切换工作的通知', date: '2023-12-04' },
        { id: 3, title: '广东省人力资源和社会保障厅 广东省财政厅关于做好阶段性降低企业职工基本养老保险费率政策实施工作的通知', date: '2023-08-02' }
      ],
      // 备用学会动态数据
      dynamicsItems: [
        { id: 1, title: '用工思维革命——新经济发展下工服明道策略探索', date: '2023-10-20' },
        { id: 2, title: '"奋进向未来"第十四届广州学术季活动—— 新时期劳动关系协调创新与工会维权实践研讨会举行', date: '2023-05-31' },
        { id: 3, title: '2023年劳动保障专业监察员培训班 圆满结束', date: '2023-05-12' },
        { id: 4, title: '"支力惠优，拒绝黑工"——应届毕业生就业权益保障公益讲座', date: '2023-05-09' },
        { id: 5, title: '关于征集广州市劳动保障学会科研业绩评审专家库的公告', date: '2023-04-14' },
        { id: 6, title: '《劳动合同法》解读讲座——疫情时代下员工管理的法律风险防范', date: '2022-07-06' },
        { id: 7, title: '两会走访副会长单位广州市保安服务有限公司', date: '2021-12-16' }
      ],
      // 案例数据
      caseData: [],
      caseLoading: true,
      caseError: null,
      // 备用案例数据
      caseItems: [
        { id: 1, title: 'HR未签订书面劳动合同，可否主张支付二倍工资差额？', date: '2024-02-20' },
        { id: 2, title: '荣借注策协议 能否认定劳动关系', date: '2023-12-18' },
        { id: 3, title: '下班后"微信办公"算加班吗？', date: '2023-12-04' }
      ],
      noticeStyle: {
        transform: 'translateX(0)',
        transition: 'transform 0s linear'
      },
      noticeScrollInterval: null,
      noticeDistance: 0,
      noticeWidth: 0,
      containerWidth: 0,
      scrollSpeed: 50, // 移动速度，单位为像素/秒
      isPaused: false,
      // 案例解说数据
      caseExamples: [
        {
          id: 1,
          title: '发包方拒不结算工程款如何办法？',
          image: 'http://www.gzhr.org.cn/api/images/view/1747980505282-126904356.jpg?token=2c6df6ed175c60c507202235d39b1798929249ecad486c9bdb6eb255f77482cf',
          free: true,
          views: 132
        },
        {
          id: 2,
          title: '劳动仲裁可以由用人单位提出吗',
          image: 'http://www.gzhr.org.cn/api/images/view/1747980510085-735132628.jpg?token=bdb62f5fd806728fdf66997964ba02e8ecf0a4498f1db4798c0bef48e4881139',
          free: true,
          views: 87
        },
        {
          id: 3,
          title: '限制产量的保价自救行为是否构成垄断行为？',
          image: 'http://www.gzhr.org.cn/api/images/view/1747980543517-485713705.jpg?token=05449f985c911a91b29198e24f3bc777f8cf4798c9ca92d205128fec363b99e1',
          free: true,
          views: 245
        },
        {
          id: 4,
          title: '2018年最新离婚财产分割案例',
          image: 'http://www.gzhr.org.cn/api/images/view/1747980550995-738175093.jpg?token=f57d5b10d26c9b7d4392188be67a3b4d5257effd73f82dabeeaf56ac5f5badf2',
          free: true,
          views: 176
        }
      ],
      messageForm: {
        name: '',
        contact: '',
        content: ''
      },
      isSubmitting: false,
      messageStatus: null,
      
      // 提示框数据
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      toastTimeout: null,
      // 新春祝福层
      showNewYearOverlay: true,
      newYearOverlayTimer: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
/*    显示新春祝福层（每次进入首页都会显示）
      this.startNewYearOverlay();
*/
      this.initNoticeScroll();
      // 窗口大小改变时重新初始化
      window.addEventListener('resize', this.initNoticeScroll);
      
      // 获取数据
      this.fetchBannerData();
      this.fetchNewsData();
      this.fetchPolicyData();
      this.fetchDynamicData();
      this.fetchCaseData();
      this.fetchCaseExamples();
      this.fetchAnnouncementData();
      
      // 初始化轮播图自动播放
      this.startAutoplay();
    });
  },
  beforeUnmount() {
    this.clearNoticeInterval();
    this.stopAutoplay();
    if (this.newYearOverlayTimer) {
      clearTimeout(this.newYearOverlayTimer);
      this.newYearOverlayTimer = null;
    }
    window.removeEventListener('resize', this.initNoticeScroll);
  },
  methods: {
/*  新春祝福层：启动并在5秒后自动关闭
    startNewYearOverlay() {
      this.showNewYearOverlay = true;
      if (this.newYearOverlayTimer) {
        clearTimeout(this.newYearOverlayTimer);
      }
      this.newYearOverlayTimer = setTimeout(() => {
        this.showNewYearOverlay = false;
      }, 5000);
    },
    // 手动关闭祝福层
    closeNewYearOverlay() {
      this.showNewYearOverlay = false;
      if (this.newYearOverlayTimer) {
        clearTimeout(this.newYearOverlayTimer);
        this.newYearOverlayTimer = null;
      }
    },*/
    // 获取轮播图数据
    async fetchBannerData() {
      this.bannerLoading = true;
      this.bannerError = null;
      
      try {
        const response = await bannerService.getActiveBanners();
        
        if (response.data && response.data.length > 0) {
          this.bannerSlides = response.data;
        } else {
          // 如果没有数据，使用默认数据
          this.bannerSlides = this.defaultBannerSlides;
        }
      } catch (error) {
        console.error('获取轮播图数据失败:', error);
        this.bannerError = '获取轮播图数据失败，使用默认数据';
        this.bannerSlides = this.defaultBannerSlides;
      } finally {
        this.bannerLoading = false;
      }
    },
    
    // 开始轮播图自动播放
    startAutoplay() {
      this.stopAutoplay(); // 先清除可能存在的定时器
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000); // 每5秒切换一次
    },
    
    // 停止轮播图自动播放
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    
    // 暂停轮播（鼠标悬停时）
    pauseAutoplay() {
      this.isAutoplayPaused = true;
      this.stopAutoplay();
    },
    
    // 恢复轮播（鼠标离开时）
    resumeAutoplay() {
      this.isAutoplayPaused = false;
      this.startAutoplay();
    },
    
    // 切换到上一张轮播图
    prevSlide() {
      this.currentSlideIndex = (this.currentSlideIndex - 1 + this.bannerSlides.length) % this.bannerSlides.length;
      this.restartAutoplay();
    },
    
    // 切换到下一张轮播图
    nextSlide() {
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.bannerSlides.length;
      this.restartAutoplay();
    },
    
    // 直接设置轮播图索引
    setSlide(index) {
      this.currentSlideIndex = index;
      this.restartAutoplay();
    },
    
    // 重新开始自动播放（用户交互后）
    restartAutoplay() {
      this.startAutoplay();
    },
    
    // 获取新闻数据
    async fetchNewsData() {
      this.newsLoading = true;
      this.newsError = null;
      
      try {
        const response = await newsService.getNewsList({ 
          page: 1,
          limit: 7
        });
        
        if (response.data && response.data.data) {
          // 处理新闻数据，检查是否有外部链接
          this.newsData = response.data.data.map(item => {
            // 检查是否有存储在content中的外部链接
            if (item.content && typeof item.content === 'string') {
              const linkMatch = item.content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
              if (linkMatch && linkMatch[1]) {
                item.externalLink = linkMatch[1];
              }
            }
            return item;
          });
        } else {
          throw new Error('返回数据格式不正确');
        }
      } catch (error) {
        console.error('获取新闻数据失败:', error);
        this.newsError = '获取数据失败，请稍后重试';
        
        // 加载失败时使用备用数据
        this.newsData = this.newsItems.map(item => ({
          id: item.id,
          title: item.title,
          publishDate: new Date(item.date)
        }));
      } finally {
        this.newsLoading = false;
      }
    },
    
    // 获取政策法规数据
    async fetchPolicyData() {
      this.policyLoading = true;
      this.policyError = null;
      
      try {
        const response = await policyService.getPolicyList({ 
          page: 1,
          limit: 7
        });
        
        if (response.data && response.data.data) {
          // 处理政策数据，检查是否有外部链接
          this.policyData = response.data.data.map(item => {
            // 检查是否有存储在content中的外部链接
            if (item.content && typeof item.content === 'string') {
              const linkMatch = item.content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
              if (linkMatch && linkMatch[1]) {
                item.externalLink = linkMatch[1];
              }
            }
            return item;
          });
        } else {
          throw new Error('返回数据格式不正确');
        }
      } catch (error) {
        console.error('获取政策法规数据失败:', error);
        this.policyError = '获取数据失败，请稍后重试';
        
        // 加载失败时使用备用数据
        this.policyData = this.policyItems.map(item => ({
          id: item.id,
          title: item.title,
          publishDate: new Date(item.date)
        }));
      } finally {
        this.policyLoading = false;
      }
    },
    
    // 获取学会动态数据
    async fetchDynamicData() {
      this.dynamicLoading = true;
      this.dynamicError = null;
      
      try {
        const response = await dynamicService.getDynamicList({ 
          page: 1,
          limit: 7
        });
        
        if (response.data && response.data.data) {
          // 处理动态数据，检查是否有外部链接
          this.dynamicData = response.data.data.map(item => {
            // 检查是否有存储在content中的外部链接
            if (item.content && typeof item.content === 'string') {
              const linkMatch = item.content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
              if (linkMatch && linkMatch[1]) {
                item.externalLink = linkMatch[1];
              }
            }
            return item;
          });
        } else {
          throw new Error('返回数据格式不正确');
        }
      } catch (error) {
        console.error('获取学会动态数据失败:', error);
        this.dynamicError = '获取数据失败，请稍后重试';
        
        // 加载失败时使用备用数据
        this.dynamicData = this.dynamicsItems.map(item => ({
          id: item.id,
          title: item.title,
          publishDate: new Date(item.date)
        }));
      } finally {
        this.dynamicLoading = false;
      }
    },
    
    // 获取案例数据
    async fetchCaseData() {
      this.caseLoading = true;
      this.caseError = null;
      
      try {
        // 使用 caseLaw 接口获取最新案例数据
        const response = await caseLawService.getAllCaseLaws();
        
        if (response.data) {
          // 只取前3条数据，并处理外部链接
          this.caseData = response.data.slice(0, 3).map(item => {
            // 检查是否有存储在content中的外部链接
            if (item.content && typeof item.content === 'string') {
              const linkMatch = item.content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
              if (linkMatch && linkMatch[1]) {
                item.externalLink = linkMatch[1];
              }
            }
            return item;
          });
        } else {
          throw new Error('返回数据格式不正确');
        }
      } catch (error) {
        console.error('获取案例数据失败:', error);
        this.caseError = '获取数据失败，请稍后重试';
        
        // 加载失败时使用备用数据
        this.caseData = this.caseItems.map(item => ({
          id: item.id,
          title: item.title,
          publishDate: new Date(item.date)
        }));
      } finally {
        this.caseLoading = false;
      }
    },
    
    // 获取案例解说数据
    async fetchCaseExamples() {
      try {
        // 这里可以添加从API获取案例解说数据的逻辑
        // 例如：const response = await caseLawService.getCaseExamples();
        
        // 处理案例解说数据，检查是否有外部链接
        this.caseExamples = this.caseExamples.map(item => {
          // 检查是否有存储在content中的外部链接
          if (item.content && typeof item.content === 'string') {
            const linkMatch = item.content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
            if (linkMatch && linkMatch[1]) {
              item.externalLink = linkMatch[1];
            }
          }
          return item;
        });
      } catch (error) {
        console.error('获取案例解说数据失败:', error);
        // 如果失败，保持使用默认数据
      }
    },
    
    // 获取公告数据（学会通知）
    async fetchAnnouncementData() {
      this.announcementLoading = true;
      this.announcementError = null;
      
      try {
        const response = await newsService.getNewsList({ 
          page: 1,
          limit: 6,
          category: '学会通知'
        });
        
        if (response.data && response.data.data) {
          // 处理公告数据
          this.announcementItems = response.data.data.map(item => {
            // 检查是否有外部链接
            let link = `/news/${item.id}`;
            if (item.content && typeof item.content === 'string') {
              const linkMatch = item.content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
              if (linkMatch && linkMatch[1]) {
                item.externalLink = linkMatch[1];
              }
            }
            return {
              id: item.id,
              title: item.title,
              link: link,
              externalLink: item.externalLink
            };
          });
        } else {
          throw new Error('返回数据格式不正确');
        }
      } catch (error) {
        console.error('获取公告数据失败:', error);
        this.announcementError = '获取数据失败，使用默认数据';
        
        // 加载失败时使用备用数据
        this.announcementItems = this.defaultAnnouncementItems;
      } finally {
        this.announcementLoading = false;
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    },
    
    initNoticeScroll() {
      // 清除之前的定时器
      this.clearNoticeInterval();
      
      if (this.$refs.noticeText && this.$refs.noticeContent) {
        // 获取元素宽度
        this.noticeWidth = this.$refs.noticeText.offsetWidth;
        this.containerWidth = this.$refs.noticeContent.offsetWidth;
        
        // 初始位置设置为容器右侧外部
        this.setNoticePosition(this.containerWidth);
        
        // 延迟一帧后开始滚动，确保初始位置已应用
        setTimeout(() => {
          this.startNoticeScroll();
        }, 20);
      }
    },
    startNoticeScroll() {
      if (this.isPaused) {
        this.isPaused = false;
      }
      
      this.clearNoticeInterval();
      
      // 计算滚动时间，速度恒定
      const scrollDistance = this.noticeWidth + this.containerWidth;
      const totalScrollTime = scrollDistance / this.scrollSpeed * 1000;
      
      // 设置CSS过渡动画
      this.noticeStyle.transition = `transform ${totalScrollTime}ms linear`;
      
      // 设置终点位置为负的文本宽度
      this.setNoticePosition(-this.noticeWidth);
      
      // 在动画即将完成时，重置位置并重新开始
      this.noticeScrollInterval = setTimeout(() => {
        // 预先留出重设位置的时间
        this.noticeStyle.transition = 'transform 0s';
        this.setNoticePosition(this.containerWidth);
        
        // 在下一帧恢复滚动
        requestAnimationFrame(() => {
          // 给浏览器一点时间渲染新位置
          setTimeout(() => {
            this.startNoticeScroll();
          }, 20);
        });
      }, totalScrollTime - 50); // 提前一点结束，避免看到跳转
    },
    stopNoticeScroll() {
      this.isPaused = true;
      this.clearNoticeInterval();
      
      // 获取当前位置 - 使用更通用的方式获取transform值
      const computedStyle = window.getComputedStyle(this.$refs.noticeText);
      const transform = computedStyle.getPropertyValue('transform');
      let translateX = 0;
      
      if (transform && transform !== 'none') {
        // 解析transform matrix值
        const matrixValues = transform.match(/matrix.*\((.+)\)/);
        if (matrixValues && matrixValues[1]) {
          const values = matrixValues[1].split(', ');
          translateX = parseFloat(values[4] || 0);
        }
      }
      
      this.noticeDistance = translateX;
      
      // 停止动画
      this.noticeStyle.transition = 'transform 0s';
      this.setNoticePosition(this.noticeDistance);
    },
    clearNoticeInterval() {
      if (this.noticeScrollInterval) {
        clearTimeout(this.noticeScrollInterval);
        this.noticeScrollInterval = null;
      }
    },
    setNoticePosition(position) {
      this.noticeStyle.transform = `translateX(${position}px)`;
    },
    hasExternalLink(item) {
      // 检查新闻项是否包含外部链接
      if (item.externalLink) {
        return true;
      }
      
      // 检查内容中是否包含外部链接标记
      if (item.content && typeof item.content === 'string') {
        return item.content.includes('[EXTERNAL_LINK]') && item.content.includes('[/EXTERNAL_LINK]');
      }
      
      return false;
    },
    
    extractExternalLink(content) {
      // 从内容中提取外部链接
      if (content && typeof content === 'string') {
        const linkMatch = content.match(/\[EXTERNAL_LINK\](.*?)\[\/EXTERNAL_LINK\]/);
        if (linkMatch && linkMatch[1]) {
          let link = linkMatch[1].trim();
          // 确保链接有http前缀
          if (!link.startsWith('http://') && !link.startsWith('https://')) {
            link = 'http://' + link;
          }
          return link;
        }
      }
      
      return '';
    },
    navigateToCaseDetail(item) {
      // 检查是否有外部链接
      if (this.hasExternalLink(item)) {
        // 如果有外部链接，在新窗口打开
        const link = this.extractExternalLink(item.content);
        if (link) {
          // 增加浏览量
          try {
            newsService.incrementViews(item.id).catch(error => {
              console.error('增加案例浏览量失败:', error);
            });
          } catch (error) {
            console.error('增加案例浏览量失败:', error);
          }
          
          window.open(link, '_blank', 'noopener,noreferrer');
          return;
        }
      }
      
      // 否则导航到内部案例详情页
      this.$router.push(`/case-law/${item.id}`);
    },
    // 在announcements-wrapper中的a标签点击事件处理
    handleAnnouncementClick(item) {
      if (item.externalLink) {
        // 如果有外部链接，增加浏览量
        try {
          newsService.incrementViews(item.id).catch(error => {
            console.error('增加公告浏览量失败:', error);
          });
        } catch (error) {
          console.error('增加公告浏览量失败:', error);
        }
      }
    },
    handleExternalLinkClick(item, link) {
      // 增加浏览量
      try {
        newsService.incrementViews(item.id).catch(error => {
          console.error('增加浏览量失败:', error);
        });
      } catch (error) {
        console.error('增加浏览量失败:', error);
      }
      
      // 在新窗口打开外部链接
      window.open(link, '_blank', 'noopener,noreferrer');
    },
    submitMessage() {
      // 表单验证
      if (!this.messageForm.name || !this.messageForm.contact || !this.messageForm.content) {
        this.messageStatus = {
          type: 'error',
          text: '请填写完整信息'
        };
        // 显示错误提示框
        this.showToastMessage('请填写完整信息', 'error');
        return;
      }
      
      this.isSubmitting = true;
      this.messageStatus = null;
      
      // 使用messageService提交留言
      messageService.submitMessage(this.messageForm)
        .then((response) => {
          console.log('留言提交成功:', response);
          
          // 显示成功提示
          this.messageStatus = {
            type: 'success',
            text: '留言提交成功，感谢您的反馈！'
          };
          
          // 显示成功提示框
          this.showToastMessage('留言提交成功，感谢您的反馈！');
          
          // 清空表单
          this.messageForm = {
            name: '',
            contact: '',
            content: ''
          };
        })
        .catch(error => {
          console.error('提交留言失败:', error);
          
          // 显示错误提示
          let errorMessage = '提交失败，请稍后重试';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          
          this.messageStatus = {
            type: 'error',
            text: errorMessage
          };
          
          // 显示错误提示框
          this.showToastMessage(errorMessage, 'error');
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    
    // 显示提示框
    showToastMessage(message, type = 'success') {
      // 清除之前的定时器
      if (this.toastTimeout) {
        clearTimeout(this.toastTimeout);
      }
      
      this.toastMessage = message;
      this.toastType = type;
      this.showToast = true;
      
      // 3秒后自动关闭
      this.toastTimeout = setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
  },
  watch: {
    isPaused(newVal) {
      if (!newVal) {
        this.startNoticeScroll();
      }
    }
  },
  computed: {
    toastIcon() {
      return this.toastType === 'success' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle';
    }
  }
}
</script>


<style lang="scss" scoped>
.home {
  padding: 0;
  
  /* 新春祝福全屏层 */
  .newyear-overlay {
    position: fixed;
    inset: 0;
    /* 纯红系渐变，去掉偏白高光 */
    background: radial-gradient(circle at top, #ff5252 0, #e53935 25%, #d81b24 55%, #7c0e13 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9998;
    pointer-events: auto;
  }

  .newyear-content {
    position: relative;
    text-align: center;
    color: #fff3e0;
    padding: 40px 20px;
    max-width: 820px;
    margin: 0 16px;
  }

  .newyear-main-text {
    font-size: 64px;
    font-weight: 900;
    letter-spacing: 14px;
    margin-bottom: 16px;
    color: #ffe082;
    text-shadow: 0 0 22px rgba(255, 235, 59, 0.95), 0 4px 14px rgba(0, 0, 0, 0.6);
  }

  .newyear-sub-text {
    font-size: 20px;
    letter-spacing: 4px;
    margin-bottom: 10px;
  }

  .newyear-org {
    font-size: 16px;
    letter-spacing: 3px;
    margin-bottom: 12px;
    color: #ffecb3;
  }

  .newyear-tips {
    font-size: 13px;
    color: #ffe0b2;
    opacity: 0.9;
  }

  .newyear-close-btn {
    position: absolute;
    top: 16px;
    right: 22px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid rgba(255, 224, 178, 0.8);
    background: rgba(120, 0, 20, 0.85);
    color: #ffe082;
    font-size: 20px;
    line-height: 30px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .newyear-close-btn:hover {
    background: rgba(255, 214, 102, 0.95);
    color: #8b0000;
    transform: scale(1.05);
  }
  
  .notice-bar {
    background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%);
    padding: 7px 28px;
    box-shadow: none;
    border-bottom: 1px solid rgba(25, 118, 210, 0.3);
    display: flex;
    align-items: center;
    position: relative;
    font-family: "Microsoft YaHei", sans-serif;
    color: #fff;
    overflow: hidden;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
      opacity: 0.1;
      z-index: 1;
    }

    .notice-icon {
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(4px);
      width: 36px;
      height: 36px;
      margin-right: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      position: relative;
      z-index: 2;

      .icon-img {
        width: 18px;
        height: 18px;
        filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0,0,0,0.1));
      }
    }

    .notice-content {
      flex: 1;
      overflow: hidden;
      position: relative;
      z-index: 2;

      .notice-text {
        white-space: nowrap;
        font-size: 15.5px;
        letter-spacing: 0.3px;
        text-shadow: 0 1px 2px rgba(0,0,0,0.1);

        .notice-item {
          display: inline-block;
          font-weight: 400;
        }
      }
    }
  }

  .page-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 15px;
  }
  
  .container {
    padding: 0;
  }

  .top-section {
    display: flex;
    margin-top: 15px;
    margin-bottom: 30px;
    gap: 20px;
    box-shadow: none;
    flex-wrap: wrap;
  }

  .banner {
    padding-left: 0;
    flex: 1.83;

    .slider {
      position: relative;
      height: 420px;
      overflow: hidden;
      border-radius: 8px;
      box-shadow: none;
      border: 1px solid #e0e0e0;
      background: #f4f8fc;
    }

    .slider-item {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
      transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      align-items: center;
      justify-content: center;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70%;
        background: linear-gradient(to top,
            rgba(25, 118, 210, 0.6) 0%,
            rgba(0, 0, 0, 0.3) 50%,
            transparent 100%
        );
        z-index: 1;
        pointer-events: none;
      }

      &.active {
        opacity: 1;
        z-index: 2;
      }
      
      a {
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
      }
    }

    .slider-img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      border-radius: 8px;
      box-shadow: none;
      display: block;
    }

    .slider-text {
      position: absolute;
      bottom: 40px;
      left: 0;
      width: 100%;
      padding: 22px 40px;
      color: #fff;
      font-size: 22px;
      font-weight: 700;
      line-height: 1.4;
      z-index: 2;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
      background: rgba(25, 118, 210, 0.25);
      backdrop-filter: blur(4px);
      border-radius: 0 0 8px 8px;
      letter-spacing: 0.5px;
    }

    .slider-indicators {
      position: absolute;
      bottom: 24px;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      z-index: 3;
      gap: 8px;
    }

    .slider-indicator {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: rgba(255,255,255,0.8);
      box-shadow: none;
      border: 1px solid rgba(25, 118, 210, 0.3);
      cursor: pointer;
      opacity: 0.8;
      transition: all 0.3s;

      &.active {
        background: #1976d2;
        border: 1px solid #fff;
        transform: scale(1.1);
        box-shadow: none;
      }
    }

    .slider-arrows {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      pointer-events: none;

      .slider-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 48px;
        height: 48px;
        background: rgba(25, 118, 210, 0.12);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
        pointer-events: auto;
        box-shadow: none;
        border: 1px solid rgba(255, 255, 255, 0.5);

        &:hover {
          background: #1976d2;
          box-shadow: none;
          transform: translateY(-50%) scale(1.08);
        }

        &.prev {
          left: 24px;
        }

        &.next {
          right: 24px;
        }

        .arrow-icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-top: 3px solid #fff;
          border-right: 3px solid #fff;
          border-radius: 2px;

          &.left {
            transform: rotate(-135deg);
          }

          &.right {
            transform: rotate(45deg);
          }
        }
      }
    }

    &:hover {
      .slider-arrow {
        opacity: 1;
      }
    }
  }

  .announcement-list {
    width: 270px;
    background-color: #fff;
    border-radius: 8px;
    padding: 0 0 12px 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    height: 420px;
    border: 1px solid #e0e0e0;
    overflow: hidden;

    .announcement-image {
      height: 120px;
      width: 100%;
      overflow: hidden;
      position: relative;

      &:after {
        content: '通知公告';
        position: absolute;
        top: -20%;
        left: 0;
        width: 100%;
        height: 120%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(25, 118, 210, 0.7);
        color: #fff;
        font-size: 22px;
        font-weight: bold;
        letter-spacing: 2px;
      }

      .announcement-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .announcements-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 10px 12px 6px 12px;
    }

    .announcement-loading, .announcement-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      text-align: center;
      padding: 10px;
    }

    .announcement-loading {
      color: #888;
      
      .spinner-small {
        width: 24px;
        height: 24px;
        border: 2px solid rgba(25, 118, 210, 0.1);
        border-top-color: #1976d2;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 8px;
      }
    }

    .announcement-error {
      color: #e53935;
      font-size: 13px;
      
      .retry-button-small {
        background: #1976d2;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 5px 12px;
        margin-top: 8px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        transition: background 0.3s;
        
        &:hover {
          background: #1565c0;
        }
      }
    }

    .announcement-item {
      display: flex;
      align-items: flex-start;
      padding: 7px 0;
      border-bottom: 1px solid #f0f0f0;
      position: relative;

      &:last-child {
        border-bottom: none;
      }

      .dot {
        width: 5px;
        height: 5px;
        background-color: #1976d2;
        border-radius: 50%;
        margin-right: 8px;
        flex-shrink: 0;
        margin-top: 8px;
      }

      .announcement-text {
        color: #333;
        font-size: 13.5px;
        line-height: 1.5;
        transition: all 0.3s;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: calc(100% - 13px);
        font-weight: normal;
        text-decoration: none;

        &:hover {
          color: #1976d2;
          transform: translateX(3px);
        }
        
        .external-link-icon-small {
          display: inline-block;
          margin-left: 3px;
          color: #1976d2;
          font-size: 10px;
        }
      }
    }
  }

  .content-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    width: 100%;
  }

  .left-content,
  .center-content,
  .right-content {
    padding: 0 10px;
    margin-bottom: 15px;
  }

  .left-content,
  .center-content {
    flex: 1;
    min-width: 300px;
  }

  .right-content {
    width: 270px;
  }

  .card {
    border-radius: 8px;
    box-shadow: none;
    transition: all 0.3s ease;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    height: 320px;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    overflow: hidden;

    &:hover {
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transform: translateY(-3px);
    }

    .card-header {
      padding: 12px 20px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 18px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f9f9f9;
      .icon-title {
        color: #1976d2;
        font-weight: 700;
        font-size: 16px;
        padding-left: 15px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 18px;
          background: #1976d2;
          border-radius: 2px;
        }
      }
      .more {
        color: #1976d2;
        font-weight: 500;
        font-size: 14px;
        transition: color 0.3s;
        text-decoration: none;
        &:hover {
          color: #1565c0;
          text-decoration: underline;
        }
      }
    }
    .card-body {
      padding: 12px 15px;
      flex: 1;
      overflow: auto;
      display: flex;
      flex-direction: column;
      background: #fff;
    }
  }

  .list {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;

    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 8px;
      margin-bottom: 6px;
      border-radius: 6px;
      transition: all 0.3s;
      position: relative;
      background: #ffffff;
      border-left: 3px solid transparent;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        background: rgba(25, 118, 210, 0.05);
        border-left: 3px solid #1976d2;
        padding-left: 12px;

        .title {
          color: #1976d2;
        }
      }
    }

    .title {
      max-width: 75%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #333;
      transition: all 0.3s;
      position: relative;
      padding-left: 16px;
      font-weight: 500;
      line-height: 1.5;
      font-size: 14.5px;
      text-decoration: none;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        background: #1976d2;
        border-radius: 50%;
        box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.15);
      }
      
      .external-link-icon {
        display: inline-block;
        margin-left: 5px;
        color: #1976d2;
        font-size: 12px;
      }
    }

    .date {
      color: #666;
      font-size: 13px;
      letter-spacing: 0.5px;
      background: rgba(25, 118, 210, 0.08);
      padding: 2px 8px;
      border-radius: 12px;
      font-weight: 500;
    }
  }

  .card.login-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: none;
    border: 1px solid #e0e0e0;
    padding: 16px 16px 15px 16px;
    min-height: 320px;
    max-height: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 15px;
    overflow: visible;  /* 修改为visible，避免出现滚动条 */
  }
  
  .card.login-card .card-header {
    width: 100%;
    background: transparent;
    border-bottom: none;
    padding: 0 0 10px 0;  /* 减小底部内边距 */
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: #1976d2;
    letter-spacing: 0.5px;
    .icon-title {
      position: relative;
      padding-left: 15px;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background: #1976d2;
        border-radius: 2px;
      }
    }
  }
  
  .card.login-card .card-body {
    width: 100%;
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;  /* 改为从顶部开始布局 */
  }
  
  .card.login-card .login-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 5px;
    width: 100%;
  }

  .card.login-card .form-group {
    margin-bottom: 0;
  }
  
  .card.login-card .form-label {
    font-size: 15px;
    color: #1976d2;
    font-weight: 600;
    margin-bottom: 4px;
    display: block;
  }
  
  .card.login-card .form-control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 14px;  /* 减小字体大小 */
    background: #fff;
    color: #222;
    transition: border-color 0.2s;
  }
  
  .card.login-card .form-control:focus {
    border-color: #1976d2;
    background: #fff;
    box-shadow: none;
    outline: none;
  }
  
  .card.login-card .btn-login {
    background: #1976d2;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 700;
    padding: 10px 0;
    box-shadow: none;
    transition: background 0.3s, transform 0.2s;
    letter-spacing: 0.5px;
  }
  
  .card.login-card .btn-login:hover {
    background: #1565c0;
    box-shadow: none;
  }
  
  .card.login-card .btn-login:active {
    transform: scale(0.98);
  }
  
  .card.login-card .form-links {
    display: flex;
    justify-content: center;
    gap: 24px;
    margin-top: 8px;
  }
  
  .card.login-card .form-link {
    color: #1976d2;
    font-size: 14px;
    text-decoration: none;
    transition: color 0.3s, text-decoration 0.3s;
  }
  
  .card.login-card .form-link:hover {
    color: #1565c0;
    text-decoration: underline;
  }

  .case-section {
    margin-top: 1px;
    margin-bottom: 50px;
    .section-header {
      padding-left: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 28px;
      padding-bottom: 12px;
      border-bottom: 2px solid #e3e8ee;
      .section-title {
        font-size: 22px;
        font-weight: 800;
        color: #1976d2;
        padding-left: 18px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 22px;
          background-color: #1976d2;
          border-radius: 3px;
        }
      }
      .more-link {
        color: #1976d2;
        font-size: 15px;
        font-weight: 500;
        transition: color 0.3s, text-decoration 0.3s;
        text-decoration: none;
        &:hover {
          color: #1565c0;
          text-decoration: underline;
        }
      }
    }
    .case-examples {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 24px;
    }
    .case-example {
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px rgba(0,0,0,0.06);
      display: flex;
      flex-direction: column;
      cursor: pointer;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 4px 16px rgba(0,0,0,0.10);

        .case-image-wrapper img {
          transform: scale(1.08);
        }
        
        .case-title {
          color: #1976d2;
        }
      }

      .case-image-wrapper {
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
      }

      .case-info {
        padding: 18px;
        display: flex;
        align-items: flex-start;
        position: relative;

        .case-title {
          color: #333;
          font-size: 16.5px;
          font-weight: 500;
          line-height: 1.5;
          max-height: 44px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          transition: color 0.3s;
          text-decoration: none;
          flex: 1;
        }

        .case-free {
          position: absolute;
          top: -12px;
          right: 15px;
          background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
          color: white;
          font-size: 13px;
          padding: 3px 10px;
          border-radius: 4px;
          font-weight: bold;
          box-shadow: 0 2px 8px rgba(76, 175, 80, 0.2);
        }
      }

      .case-views {
        padding: 0 15px 15px;
        display: flex;
        justify-content: flex-end;

        .views-count {
          color: #888;
          font-size: 13px;

          &:before {
            content: '👁 ';
            margin-right: 3px;
          }
        }
      }
    }
  }

  .loading-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #888;
    
    .spinner-small {
      width: 30px;
      height: 30px;
      border: 3px solid rgba(25, 118, 210, 0.1);
      border-top-color: #1976d2;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 10px;
    }
  }
  
  .error-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #e53935;
    text-align: center;
    
    .retry-button {
      background: #1976d2;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 8px 16px;
      margin-top: 10px;
      cursor: pointer;
      font-weight: 500;
      transition: background 0.3s;
      
      &:hover {
        background: #1565c0;
      }
    }
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @media (max-width: 1200px) {
    .page-container {
      max-width: 100%;
    }
    
    .banner {
      flex: 1.66;
    }
    
    .announcement-list {
      width: 250px;
      
      .announcement-item .announcement-text {
        font-size: 13px;
      }
    }
    
    .right-content {
      width: 250px;
    }
    
    .card.login-card {
      padding: 14px 14px 12px 14px;
    }
  }

  @media (max-width: 992px) {
    .page-container {
      padding: 0 12px;
    }
    
    .top-section {
      flex-direction: column;
    }
    
    .banner {
      flex: 1;
    }

    .announcement-list {
      width: 100%;
      height: 260px;
      border-radius: 8px;

      .announcement-image {
        height: 100px;

        &:after {
          font-size: 20px;
        }
      }

      .announcements-wrapper {
        padding: 12px 16px 6px 16px;
      }

      .announcement-item {
        padding: 10px 0;

        .announcement-text {
          font-size: 14px;
        }
      }
    }

    .content-wrapper {
      flex-direction: column;
    }

    .right-content {
      width: 100%;
    }

    .banner {
      .slider {
        height: 260px;
        border-radius: 8px;
      }
      .slider-img {
        border-radius: 8px;
        object-fit: fill;
      }
      .slider-text {
        font-size: 18px;
        padding: 12px 18px;
        bottom: 32px;
        border-radius: 0 0 8px 8px;
      }
      .slider-item:before {
        height: 80%;
      }
      .slider-indicator {
        width: 12px;
        height: 12px;
      }
      .slider-arrow {
        width: 36px;
        height: 36px;
      }
    }
    
    .case-section {
      margin-top: 20px;
      margin-bottom: 25px;
      
      .section-header {
        margin-bottom: 15px;
        padding-bottom: 8px;
      }
    }
    
    .card.login-card {
      padding: 20px 20px 15px 20px;
    }
    
    .message-textarea {
      min-height: 70px;  /* 在平板设备上增加文本框高度 */
    }
  }

  @media (max-width: 576px) {
    .page-container {
      padding: 0 10px;
    }
    
    .notice-bar {
      padding: 10px 15px;

      .notice-icon {
        margin-right: 10px;
      }
    }

    .banner {
      .slider {
        height: 160px;
        border-radius: 6px;
      }
      .slider-img {
        border-radius: 6px;
        object-fit: fill;
      }
      .slider-text {
        font-size: 14px;
        padding: 8px 12px;
        bottom: 24px;
        border-radius: 0 0 6px 6px;
      }
      .slider-item:before {
        height: 90%;
      }
      .slider-indicator {
        width: 8px;
        height: 8px;
      }
      .slider-arrow {
        width: 24px;
        height: 24px;
      }
    }

    .case-examples {
      grid-template-columns: 1fr;
    }
    .card {
      border-radius: 6px;
      margin-bottom: 15px;
      
      .card-header {
        padding: 10px 15px;
        
        .icon-title {
          font-size: 15px;
          padding-left: 10px;
          
          &:before {
            width: 3px;
            height: 15px;
          }
        }
      }
      
      .card-body {
        padding: 10px 12px;
      }
    }
    .case-section {
      margin-top: 15px;
      margin-bottom: 15px;
      
      .section-header {
        margin-bottom: 10px;
        padding-bottom: 4px;
        padding-left: 5px;
        
        .section-title {
          font-size: 16px;
          padding-left: 8px;
          &:before {
            width: 3px;
            height: 14px;
          }
        }
      }
    }
    
    .content-wrapper {
      margin: 0 -5px;
    }
    
    .left-content,
    .center-content,
    .right-content {
      padding: 0 5px;
    }

    .list {
      .list-item {
        padding: 8px 6px;
        margin-bottom: 4px;
      }
      
      .title {
        font-size: 13.5px;
        padding-left: 12px;
        
        &:before {
          width: 4px;
          height: 4px;
        }
      }
      
      .date {
        font-size: 11px;
        padding: 1px 6px;
      }
    }
    
    .message-textarea {
      min-height: 60px;  /* 在手机设备上减小文本框高度 */
    }
    
    .message-form {
      gap: 8px;  /* 在手机设备上进一步减小间距 */
    }
    
    .btn-submit {
      padding: 6px 0;  /* 在手机设备上减小按钮高度 */
      font-size: 14px;  /* 在手机设备上减小按钮字体 */
    }
  }
}

.card-body,
.list,
.case-examples {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.card-body::-webkit-scrollbar,
.list::-webkit-scrollbar,
.case-examples::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Webkit */
}

@keyframes infinite-rotate {
  100% { transform: rotate(360deg); }
}
.notice-icon .icon-img:hover {
  animation: infinite-rotate 0.5s linear infinite;
  filter: drop-shadow(0 0 8px #fff) drop-shadow(0 0 16px #1976d2);
  box-shadow: none;
}

/* 留言板样式 */
.message-form {
  display: flex;
  flex-direction: column;
  gap: 8px;  /* 进一步减小间距 */
  width: 100%;
}

.message-textarea {
  resize: none;
  min-height: 40px;  /* 减小文本框高度为两行 */
  font-family: inherit;
}

.form-group {
  margin-bottom: 0;
}

.form-label {
  margin-bottom: 2px;  /* 减小标签底部间距 */
  display: block;
}

.form-control {
  padding: 8px 12px;  /* 减小内边距 */
}

.btn-submit {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 15px;  /* 减小字体大小 */
  font-weight: 700;
  padding: 8px 0;  /* 减小按钮高度 */
  box-shadow: none;
  transition: background 0.3s, transform 0.2s;
  letter-spacing: 0.5px;
  cursor: pointer;
  margin-top: 2px;  /* 增加顶部间距 */
}

.btn-submit:hover {
  background: #1565c0;
  box-shadow: none;
}

.btn-submit:active {
  transform: scale(0.98);
}

.btn-submit:disabled {
  background: #90caf9;
  cursor: not-allowed;
}

.message-status {
  margin-top: 6px;  /* 减小顶部间距 */
  padding: 5px 10px;  /* 减小内边距 */
  border-radius: 4px;
  font-size: 13px;  /* 减小字体大小 */
  text-align: center;
}

.message-status.success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #2e7d32;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.message-status.error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #d32f2f;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

/* 自定义提示框样式 */
.custom-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 300px;
  max-width: 80%;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideDown 0.3s ease-out forwards;
  
  &.success {
    background-color: #f0f9eb;
    border: 1px solid #e1f3d8;
    color: #67c23a;
  }
  
  &.error {
    background-color: #fef0f0;
    border: 1px solid #fde2e2;
    color: #f56c6c;
  }
  
  .toast-content {
    display: flex;
    align-items: center;
    
    .toast-icon {
      margin-right: 10px;
      font-size: 20px;
    }
    
    .toast-message {
      font-size: 16px;
      line-height: 1.5;
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
</style>
